import React from 'react';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import ProgramExcellence from './components/Program-Excellence';
import AIInternshipJourney from './components/AI-Internship-Journey';

const AIInternshipProgram = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 50%, #a5b4fc 100%)',
      fontFamily: 'Arial, sans-serif',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      position: 'relative'
    },

    contentWrapper: {
      textAlign: 'center',
      maxWidth: '800px',
      margin: '0 auto'
    },

    mainTitle: {
      fontSize: '3.5rem',
      fontWeight: 'bold',
      color: '#1e293b',
      marginBottom: '8px',
      lineHeight: '1.2'
    },

    highlightedText: {
      color: '#4f46e5',
      background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text'
    },

    subtitle: {
      fontSize: '1.2rem',
      color: '#64748b',
      maxWidth: '600px',
      margin: '0 auto 40px auto',
      lineHeight: '1.6',
      fontWeight: '400'
    },

    buttonContainer: {
      display: 'flex',
      gap: '20px',
      justifyContent: 'center',
      marginBottom: '40px',
      flexWrap: 'wrap'
    },

    applyButton: {
      background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '12px 32px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },

    learnMoreButton: {
      background: 'transparent',
      color: '#4f46e5',
      border: '2px solid #4f46e5',
      borderRadius: '8px',
      padding: '10px 32px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },

    poweredBy: {
      fontSize: '14px',
      color: '#64748b',
      marginTop: '20px'
    },

    poweredByLink: {
      color: '#4f46e5',
      textDecoration: 'none',
      fontWeight: '600'
    },

    decorativeElements: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      overflow: 'hidden'
    },

    circle1: {
      position: 'absolute',
      width: '200px',
      height: '200px',
      borderRadius: '50%',
      background: 'rgba(79, 70, 229, 0.1)',
      top: '15%',
      left: '10%',
      animation: 'float 6s ease-in-out infinite'
    },

    circle2: {
      position: 'absolute',
      width: '150px',
      height: '150px',
      borderRadius: '50%',
      background: 'rgba(124, 58, 237, 0.1)',
      bottom: '20%',
      right: '15%',
      animation: 'float 4s ease-in-out infinite reverse'
    },

    circle3: {
      position: 'absolute',
      width: '100px',
      height: '100px',
      borderRadius: '50%',
      background: 'rgba(79, 70, 229, 0.05)',
      top: '25%',
      right: '25%',
      animation: 'float 5s ease-in-out infinite'
    },

    geometricShape1: {
      position: 'absolute',
      width: '60px',
      height: '60px',
      background: 'rgba(124, 58, 237, 0.1)',
      transform: 'rotate(45deg)',
      top: '30%',
      left: '20%',
      animation: 'rotate 8s linear infinite'
    },

    geometricShape2: {
      position: 'absolute',
      width: '40px',
      height: '40px',
      background: 'rgba(79, 70, 229, 0.1)',
      borderRadius: '20%',
      bottom: '30%',
      left: '25%',
      animation: 'pulse 3s ease-in-out infinite'
    }
  };

  return (
    <div>
    <Navbar />
    <div style={styles.container}>
      {/* Decorative Background Elements */}
      <div style={styles.decorativeElements}>
        <div style={styles.circle1}></div>
        <div style={styles.circle2}></div>
        <div style={styles.circle3}></div>
        <div style={styles.geometricShape1}></div>
        <div style={styles.geometricShape2}></div>
      </div>

      {/* Main Content */}
      <div style={styles.contentWrapper}>
        <h1 style={styles.mainTitle}>
          AI Internship<br />
          <span style={styles.highlightedText}>Training Program</span>
        </h1>

        <p style={styles.subtitle}>
          Transform your career through comprehensive AI training. Excellence in 
          performance leads to guaranteed internship opportunities with our industry-
          leading partner companies.
        </p>

        <div style={styles.poweredBy}>
          Powered by{' '}
          <p
            style={styles.poweredByLink}
          >
            Global AI Society
          </p>
        </div>
      </div>
      </div>
      <ProgramExcellence />
      <AIInternshipJourney />
      <Footer />

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes float {
          0%, 100% { 
            transform: translateY(0px) scale(1); 
            opacity: 0.7;
          }
          50% { 
            transform: translateY(-20px) scale(1.05); 
            opacity: 1;
          }
        }
        
        @keyframes rotate {
          0% { transform: rotate(45deg); }
          100% { transform: rotate(405deg); }
        }
        
        @keyframes pulse {
          0%, 100% { 
            transform: scale(1); 
            opacity: 0.6;
          }
          50% { 
            transform: scale(1.2); 
            opacity: 1;
          }
        }
        
        @media (max-width: 768px) {
          .mainTitle {
            font-size: 2.5rem;
          }
          
          .subtitle {
            font-size: 1rem;
            padding: 0 10px;
          }
          
          .buttonContainer {
            flex-direction: column;
            align-items: center;
            gap: 15px;
          }
          
          .applyButton, .learnMoreButton {
            width: 100%;
            max-width: 250px;
          }
        }
        
        @media (max-width: 480px) {
          .contentWrapper {
            padding: 0 15px;
          }
          
          .mainTitle {
            font-size: 2rem;
          }
        }
      `}</style>
    </div>
  );
};

export default AIInternshipProgram;